import { jsx as _jsx } from "react/jsx-runtime";
import { ComponentSync } from '@nu-art/thunderstorm-frontend/core/ComponentSync';
import './GraphvizViewer.scss';
import { toDot } from 'ts-graphviz';
import { graphviz } from 'd3-graphviz';
export class GraphvizViewer extends ComponentSync {
    deriveStateFromProps(nextProps) {
        const _dotString = nextProps.digraph ? toDot(nextProps.digraph) : nextProps.dotString;
        return { dotString: _dotString };
    }
    componentDidMount() {
        this.renderGraphviz();
    }
    renderGraphviz() {
        if (!this.state.dotString)
            return;
        graphviz('#pathway-viewer', { useWorker: false })
            .renderDot(this.state.dotString);
    }
    render() {
        if (!this.state.dotString)
            return _jsx("div", { className: 'page-message', children: "No pathway to show" });
        return _jsx("div", { id: 'viewer' });
    }
}
//# sourceMappingURL=GraphvizViewer.js.map